// ts-gql-integrity:2687527616b3ab5c70c45a39a52ae190
/*
ts-gql-meta-begin
{
  "hash": "a447f6b6d5d2d99815edf9488da4dc35"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type ExportAllClientsQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


type ExportAllClientsQuery = { readonly __typename: 'Query', readonly exportClient: { readonly __typename: 'ExportClient', readonly url: string } | null };



export type type = TypedDocumentNode<{
  type: "query";
  result: ExportAllClientsQuery;
  variables: {};
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    ExportAllClients: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"ExportAllClients\"},\"variableDefinitions\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"exportClient\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"url\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
